// rem布局配置
function resetFontSize(max = 650) {
  var baseFontSize = 50;
  var designWidth = 375;
  var width = window.innerWidth > max ? max : window.innerWidth;
  var currentFontSize = (width / designWidth) * baseFontSize;
  document.getElementsByTagName("html")[0].style.fontSize =
    currentFontSize + "px";
}
window.onresize = function () {
  resetFontSize();
};
resetFontSize();

function bodyShow() {
  // let Images = new Image();
  // Images.src = require('@/images/other/alert-bg.png');
  // Images.onload = function() { //图片加载
  document.getElementsByTagName("body")[0].style.opacity = 1;
  // }
}
bodyShow();
